import React from 'react';

import { FormControl, Box, FormHelperText, TextField } from '@mui/material';

export default function LastNameField({
  value,
  error,
  setValue,
  setError,
  setChanged,
}) {
  const handleChange = (event) => {
    const { value: newValue } = event.target;
    setChanged();
    setValue(newValue);
    if (/[#^$<>+%!`&*|{}?/\\:=@]/.test(newValue)) {
      setError('Last name cannot contain #^$<>+%!`&*|{}?/\\:=@');
    } else if (newValue === '') {
      setError('Last name cannot be blank');
    } else {
      setError(false);
    }
  };

  return (
    <Box>
      <FormControl fullWidth required>
        <TextField
          label='Last Name'
          id='family_name'
          aria-describedby='last-name-helper-text'
          variant='outlined'
          onChange={handleChange}
          error={Boolean(error)}
          value={value}
        />
        {error ? (
          <FormHelperText id='last-name-helper-text'>{error}</FormHelperText>
        ) : (
          <FormHelperText id='last-name-helper-text'>
            Enter your last (family) name.
          </FormHelperText>
        )}
      </FormControl>
    </Box>
  );
}
